import { useState } from "react";
import { Stethoscope } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Solo clients (including released ones) can join a clinician later with that clinician's invite code. */
export function LinkClinicianCard() {
  const { user, setUser } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.role !== "client" || user.clinician_id || user.is_demo) return null;
  const link = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/users/link-clinician", { code });
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success(`Connected to ${data.clinician_name}. They can now see your progress.`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="warm-card p-6 space-y-3" data-testid="link-clinician-card">
      <div className="flex items-start gap-3">
        <Stethoscope className="w-6 h-6 text-emerald-700 mt-0.5" />
        <div>
          <h3 className="font-display text-lg font-bold text-stone-900">Connect to a coach</h3>
          <p className="text-sm text-stone-600 mt-0.5">Working with a therapist who uses Root & Rose? Enter their invite code and they'll see your habits, wellbeing check-ins and rewards. You can be unlinked at any time.</p>
        </div>
      </div>
      <form onSubmit={link} className="flex gap-2 flex-wrap">
        <input data-testid="link-code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Invite code, e.g. 7F3A9C" maxLength={12} required
          className="flex-1 min-w-[10rem] px-3 py-2 rounded-xl border border-stone-300 text-sm font-mono tracking-widest focus:border-emerald-600 outline-none" />
        <button data-testid="link-submit" type="submit" disabled={busy || code.length < 4} className="px-4 py-2 rounded-full text-sm font-semibold bg-emerald-700 text-white hover:bg-emerald-800 disabled:opacity-50">{busy ? "Connecting…" : "Connect"}</button>
      </form>
    </div>
  );
}
